import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-corona',
  templateUrl: './corona.component.html',
  styleUrls: ['./corona.component.scss']
})
export class CoronaComponent implements OnInit {

  constructor(
    private title: Title,
    private meta: Meta,
  ) { }

  ngOnInit(): void {
    this.title.setTitle('Bestel eten, booschappen en winkel direct uit jouw stad! | HalloBezorger');
    this.meta.updateTag({ name: 'description', content: 'Bestel eten, booschappen en winkel direct uit jouw stad!' });
    this.meta.updateTag({ name: 'keywords', content: 'den bosch, restaurants, winkels, bezorgen, bezorging, thuisbezord' });

  }

}
